import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {ObservacionModalComponent} from '../observacion-modal/observacion-modal.component';

@Component({
  selector: 'app-num-pedido-modal',
  templateUrl: './num-pedido-modal.component.html',
  styleUrls: ['./num-pedido-modal.component.css']
})
export class NumPedidoModalComponent implements OnInit {

  numPedido: FormGroup;
  constructor(public dialogRef: MatDialogRef<NumPedidoModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, private router: Router ) {
    this.crearFormulario();
  }

  ngOnInit(): void {
  }


  crearFormulario(): any {
    this.numPedido = this.fb.group({
      num: [''],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  Guardar(): any {
    //Guardar en  session
    sessionStorage.setItem('numPedido', this.numPedido.value.num);
    this.dialogRef.close();
  }

}

